export default __webpack_public_path__ + "static/media/edit_form.2390d163.svg";